import { render, staticRenderFns } from "./ProjectOrganizationDialog.vue?vue&type=template&id=b10a0232&scoped=true&"
import script from "./ProjectOrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectOrganizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOrganizationDialog.vue?vue&type=style&index=0&id=b10a0232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10a0232",
  null
  
)

export default component.exports